import type { StudentsData } from "@/artifacts/admin/pages/Dashboard";
import { VStack } from "@/components/layout/VStack";
import { StudentsTable } from "./StudentsDataTable";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/Empty/Empty";
import { Eye, EyeClosed, UsersRound } from "lucide-react";
import { Skeleton } from "@/components/ui/Skeleton/Skeleton";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/Collapsible/Collapsible";
import { useState } from "react";
import { HStack } from "@/components/layout/HStack";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/Tooltip/Tooltip";
import { Button } from "@/components/ui/Button/Button";

const Students = ({
  data,
  loading,
  onOpen,
}: {
  data: StudentsData[] | null;
  loading: boolean;
  onOpen: (studentId: string) => void;
}) => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Collapsible
      open={open}
      onOpenChange={setOpen}
      style={{ marginTop: "-8px" }}
    >
      <VStack gap="2rem">
        <VStack gap={0}>
          <HStack>
            <h3
              style={{
                fontSize: "var(--text-lg)",
                lineHeight: "var(--line-height-lg)",
                fontWeight: "var(--font-bold)",
              }}
            >
              Students
            </h3>
            <Tooltip>
              <TooltipTrigger asChild>
                <CollapsibleTrigger asChild>
                  <Button variant="ghost" size="icon-small">
                    {open ? <EyeClosed /> : <Eye />}
                  </Button>
                </CollapsibleTrigger>
              </TooltipTrigger>
              <TooltipContent>
                {open ? "Hide" : "Show"} students section.
              </TooltipContent>
            </Tooltip>
          </HStack>
          <p style={{ color: "var(--muted-foreground)" }}>
            All active students
          </p>
        </VStack>
        <CollapsibleContent>
          {loading ? (
            <Skeleton style={{ height: "512px", width: "100%" }} />
          ) : !data || data.length < 1 ? (
            <Empty style={{ borderColor: "var(--secondary-border)" }}>
              <EmptyHeader>
                <EmptyMedia variant="icon">
                  <UsersRound />
                </EmptyMedia>
                <EmptyTitle>No Students Found</EmptyTitle>
                <EmptyDescription>
                  There were no students found. If you believe this is an error,
                  please refresh.
                </EmptyDescription>
              </EmptyHeader>
            </Empty>
          ) : (
            <StudentsTable students={data} onOpen={onOpen} />
          )}
        </CollapsibleContent>
      </VStack>
    </Collapsible>
  );
};

export { Students };
